import { useFormikContext } from 'formik'
import { useCallback, useEffect, useState } from 'react'
import { useCheckout } from './CheckoutContext'
import CardTable from '../../../../components/CardTable'
import { metodoPrograma } from '../../../../components/api'

const PropostaCard = ({ preencherAltura }) => {
  const { values } = useFormikContext()
  const { idAtendimento } = useCheckout()
  const [totalEstornado, setTotalEstornado] = useState(0)

  const carregarEstornos = useCallback(async () => {
    if (!idAtendimento) return setTotalEstornado(0)
    const resposta = await metodoPrograma(
      'resumoEstornos',
      { idAtendimento },
      'CtrlOrcamentoCheckin',
    )
    if (resposta.status) setTotalEstornado(Number(resposta.totalEstornado || 0))
  }, [idAtendimento])

  useEffect(() => {
    carregarEstornos()
  }, [carregarEstornos])

  useEffect(() => {
    window.addEventListener('estornos-atualizados', carregarEstornos)
    return () =>
      window.removeEventListener('estornos-atualizados', carregarEstornos)
  }, [carregarEstornos])

  const valorPagoLiquido = Math.max(
    0,
    Number(values.vlPago || 0) - totalEstornado,
  )

  const saldoProposta =
    (values.vlSubTotal || 0) -
    (values.vlPago || 0) -
    (values.vlDescontoGeral || 0)

  const itens = [
    { label: 'SubTotal', valor: values.vlSubTotal || 0 },
    { label: 'Valor Pago', valor: values.vlPago || 0 },
    ...(totalEstornado > 0
      ? [
          { label: 'Valor Estornado', valor: totalEstornado },
          { label: 'Valor Pago Líquido', valor: valorPagoLiquido },
        ]
      : []),
    { label: 'Valor Desconto', valor: values.vlDescontoGeral || 0 },
  ]

  return (
    <CardTable
      titulo={`Proposta #${idAtendimento || ''}`}
      dadosTabela={itens}
      maxLinhas={7}
      colunas={['Descrição', 'Valor']}
      mapear={(item) => [item.label, item.valor]}
      colunasMoeda={[1]}
      preencherAltura={preencherAltura}
      alturaMinimaLinha={0}
      compactarLinhas
      estiloColunas={[{ width: '70%' }, { width: '30%', textAlign: 'right' }]}
      rotuloTotal="Saldo Proposta"
      valorTotal={saldoProposta}
      semBordas
    />
  )
}

export default PropostaCard
